var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunityShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9,6.5c0.5-0.6,1.3-1,2.1-1c0.9,0,1.6,0.4,2.1,1c0.4,0.5,0.6,1.1,0.6,1.8c0,1.5-1.2,2.7-2.7,2.7 c0,0,0,0-0.1,0c0,0,0,0-0.1,0c-1.5,0-2.7-1.3-2.7-2.7C6.2,7.6,6.5,7,6.9,6.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8,8.2c0-0.6-0.2-1.2-0.4-1.8h4.2C17.3,6.5,18,7.2,18,8v0.5c0,1.6-1.2,3.2-3.3,3.8c-0.4-0.8-1.2-1.3-2.2-1.3 h-1C12.3,10.3,12.8,9.3,12.8,8.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,12c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.4,0.6,0.4,1V14c0,2-1.9,4-5,4c-3.1,0-5-2-5-4v-0.5 c0-0.4,0.2-0.8,0.4-1C4.7,12.2,5.1,12,5.5,12H12.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0,8.5c0,1.6,1.2,3.2,3.3,3.8C3.7,11.5,4.6,11,5.5,11h1c-0.7-0.7-1.2-1.7-1.2-2.8c0-0.6,0.2-1.2,0.4-1.8H1.5 C0.7,6.5,0,7.2,0,8V8.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8,2.8C7.8,1.2,6.5,0,5,0S2.2,1.2,2.2,2.8S3.5,5.5,5,5.5S7.8,4.3,7.8,2.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8,2.8C15.8,1.2,14.5,0,13,0s-2.8,1.2-2.8,2.8s1.2,2.8,2.8,2.8S15.8,4.3,15.8,2.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityShare);
export default __webpack_public_path__ + "static/media/community_share.d1de5a1b.svg";
export { ForwardRef as ReactComponent };